import script from "./SceneDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./SceneDesktop.vue?vue&type=script&setup=true&lang=js"

import "./SceneDesktop.vue?vue&type=style&index=0&id=2bb49db2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bb49db2"]])

export default __exports__